// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3Ne9S","colCheckbox":"styles_colCheckbox__2Vt26"};